import { Box } from '@mui/material';

export default function PageInsetTop({ sx, ...otherProps }) {
  return (
    <Box {...otherProps} sx={{ ...sx, height: { xs: 90, md: 139 } }} />
  );
}
